import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { tc, tm } from 'utils/theme';
import { setLocalAuth } from 'utils/auth';
import { PRIVACY_POLICY_URL } from 'utils/constants';
import H2 from 'components/Atoms/H2';
import P from 'components/Atoms/P';
import Link from 'components/Atoms/Link';
import Form from 'components/Organisms/FormLogin';
import { AppContext } from 'contexts/AppContext';

const LoginContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;

  @media (max-width: ${tm('tablet')}) {
    width: 100%;
  }
`;

const BlockWrapper = styled.div`
  padding: 25px 0;
`;

const FirstTimeWrapper = styled(BlockWrapper)`
  background-color: ${tc('backgroundColor')};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0898154);
  border-radius: 5px;
  padding: 30px;
`;

const PrivacyWrapper = styled.p`
  text-align: center;

  & > a {
    color: ${tc('linkColor')};
    font-size: 12px;
    text-decoration: underline;
  }
`;

const Login = ({ handleOpenTroubleLoggingInModal }) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const history = useHistory();

  const baseURL = `/${organizationId}/${propertyId}`;

  const onSubmitSuccess = ({ token, sanitizedUser }) => {
    setLocalAuth({
      token,
      sanitizedUser,
    });

    return history.push(`/${organizationId}/${propertyId}`);
  };

  return (
    <LoginContainer>
      <BlockWrapper>
        <Form
          handleOpenTroubleLoggingInModal={handleOpenTroubleLoggingInModal}
          onSubmitSuccess={onSubmitSuccess}
        />
      </BlockWrapper>
      <FirstTimeWrapper>
        <H2 center>First Time Here?</H2>
        <P>
          <strong>Resident:</strong>
          &nbsp;Please contact the leasing office to have login credentials sent
          to you.
        </P>
        <P>
          <strong>Applicant:</strong>
          &nbsp;Create an account by clicking&nbsp;
          <Link to={`${baseURL}/register`}>HERE</Link>.
        </P>
        <P>
          <strong>Note:</strong>
          &nbsp;If a member of your household has already applied, contact our
          office to have login credentials sent to you.
        </P>
        <PrivacyWrapper>
          <a
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </PrivacyWrapper>
      </FirstTimeWrapper>
    </LoginContainer>
  );
};

export default Login;
